module.exports = __webpack_public_path__ + "static/media/Refah.4158a942.svg";